export const PREFIX = 'admin-dashboard-programs~ProgramInvitations';
export const ADD_MEMBER = 'ADD_MEMBER';
export const SEND_INVITATION = 'SEND_INVITATION';
export const SEND_INVITATIONS = 'SEND_INVITATIONS';
export const RESEND_INVITATIONS = 'RESEND_INVITATIONS';
export const DELETE_INVITATION = 'DELETE_INVITATION';
export const DELETE_INVITATIONS = 'DELETE_INVITATIONS';
export const PROCESS_INVITATIONS = 'PROCESS_INVITATIONS';
